import service from "@/store/services/labels-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  label: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, label) => {
    state.label = label;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((label) => {
      commit("SET_RESOURCE", label);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((label) => {
      commit("SET_RESOURCE", label);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((label) => {
      commit("SET_RESOURCE", label);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  label: (state) => state.label,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((label) => ({
      id: label.id,
      name: label.name,
    }));
  },
};

const labels = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default labels;
